import { Box } from '@mui/material'
import { IFlowRunConfig } from '../../definitions/NodesExecution'
import { useAppSelector } from '../../store/Hooks'
import RoutingManager from '../routing/Routing'
import FlowInitializer from './FlowInitializer'
import NestedFlows from './NestedFlows'

function Flow() {
    const params = RoutingManager.getParams<{ flowId: string, eeId?: string, defaultDryRun?: boolean, flowRunConfig?: IFlowRunConfig }>(useAppSelector(s => s.session.routeParams))

    return (
        <Box flex={1} display='flex' width='100%' height='100%' position='relative'>
            <FlowInitializer key={`${params.flowId}-${params.eeId}`} flowId={params.flowId} eeId={params.eeId} flowRunConfig={params?.flowRunConfig ?? null} />
            <NestedFlows mainFlowId={params.flowId} />
        </Box>
    )
}

export default Flow
